import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, toDisplayString as _toDisplayString, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a2249af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_3 = { class: "detail" }
const _hoisted_4 = { class: "info-container" }
const _hoisted_5 = { class: "mainpic" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = { class: "btn" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "info-container" }
const _hoisted_12 = { class: "info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_button = _resolveComponent("a-button")!
  const _directive_wechat_title = _resolveDirective("wechat-title")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/mobile" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_image, {
            width: 320,
            src: _ctx.detail.img,
            alt: _ctx.detail.title,
            fallback: "https://s4.ax1x.com/2022/02/17/H5W5QO.png"
          }, null, 8, ["src", "alt"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("p", {
            textContent: _toDisplayString(_ctx.detail.title),
            class: "info-item title"
          }, null, 8, _hoisted_7), [
            [_vShow, _ctx.detail.title]
          ]),
          _createElementVNode("p", _hoisted_8, [
            _createVNode(_component_a_button, {
              type: "primary",
              class: "mr-10"
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: `${_ctx.detail.link}`,
                  target: "_blank"
                }, "磁力链接下载", 8, _hoisted_9)
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, null, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: `${_ctx.detail.url}`,
                  target: "_blank"
                }, "原文链接", 8, _hoisted_10)
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item date" }, _toDisplayString(_ctx.dict.date) + " " + _toDisplayString(_ctx.$dayjs(_ctx.detail.date).format("YYYY-MM-DD HH:mm:ss")), 513), [
            [_vShow, _ctx.detail.date]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item translation" }, _toDisplayString(_ctx.dict.translation) + " " + _toDisplayString(_ctx.detail.translation), 513), [
            [_vShow, _ctx.detail.translation]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item name" }, _toDisplayString(_ctx.dict.name) + " " + _toDisplayString(_ctx.detail.name), 513), [
            [_vShow, _ctx.detail.name]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item year" }, _toDisplayString(_ctx.dict.year) + " " + _toDisplayString(_ctx.detail.year), 513), [
            [_vShow, _ctx.detail.year]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item areas" }, _toDisplayString(_ctx.dict.areas) + " " + _toDisplayString(_ctx.detail.areas), 513), [
            [_vShow, _ctx.detail.areas]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item category" }, _toDisplayString(_ctx.dict.category) + " " + _toDisplayString(_ctx.detail.category), 513), [
            [_vShow, _ctx.detail.category]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item language" }, _toDisplayString(_ctx.dict.language) + " " + _toDisplayString(_ctx.detail.language), 513), [
            [_vShow, _ctx.detail.language]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item caption" }, _toDisplayString(_ctx.dict.caption) + " " + _toDisplayString(_ctx.detail.caption), 513), [
            [_vShow, _ctx.detail.caption]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item release" }, _toDisplayString(_ctx.dict.release) + " " + _toDisplayString(_ctx.detail.release), 513), [
            [_vShow, _ctx.detail.release]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item imdb" }, _toDisplayString(_ctx.dict.imdb) + " " + _toDisplayString(_ctx.detail.imdb) + "/10 from " + _toDisplayString(_ctx.detail.imdb_user) + " users ", 513), [
            [_vShow, _ctx.detail.imdb]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item douban" }, _toDisplayString(_ctx.dict.douban) + " " + _toDisplayString(_ctx.detail.douban) + "/10 from " + _toDisplayString(_ctx.detail.douban_user) + " users ", 513), [
            [_vShow, _ctx.detail.douban]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item time" }, _toDisplayString(_ctx.dict.time) + " " + _toDisplayString(_ctx.detail.time) + "分钟 ", 513), [
            [_vShow, _ctx.detail.time]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("p", { class: "info-item director" }, _toDisplayString(_ctx.dict.director) + " " + _toDisplayString(_ctx.detail.director), 513), [
            [_vShow, _ctx.detail.director]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item writers" }, _toDisplayString(_ctx.dict.writers) + " " + _toDisplayString(_ctx.detail.writers), 513), [
            [_vShow, _ctx.detail.writers]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item actor" }, _toDisplayString(_ctx.dict.actor) + " " + _toDisplayString(_ctx.detail.actor), 513), [
            [_vShow, _ctx.detail.actor]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item starring" }, _toDisplayString(_ctx.dict.starring) + " " + _toDisplayString(_ctx.detail.starring), 513), [
            [_vShow, _ctx.detail.starring]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item tag" }, _toDisplayString(_ctx.dict.tag) + " " + _toDisplayString(_ctx.detail.tag), 513), [
            [_vShow, _ctx.detail.tag]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info-item introduction" }, _toDisplayString(_ctx.dict.introduction) + " " + _toDisplayString(_ctx.detail.introduction), 513), [
            [_vShow, _ctx.detail.introduction]
          ])
        ])
      ])
    ])), [
      [_directive_wechat_title, _ctx.detail.title + '-电影小站']
    ])
  ], 64))
}